import script from "./Target.vue?vue&type=script&setup=true&lang=js"
export * from "./Target.vue?vue&type=script&setup=true&lang=js"

import "./Target.vue?vue&type=style&index=0&id=ee42291e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee42291e"]])

export default __exports__